import { render } from "./JoinCommunityModal.vue?vue&type=template&id=e7790f56&scoped=true"
import script from "./JoinCommunityModal.vue?vue&type=script&lang=js"
export * from "./JoinCommunityModal.vue?vue&type=script&lang=js"

import "./JoinCommunityModal.vue?vue&type=style&index=0&id=e7790f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7790f56"]])

export default __exports__